import styled, { keyframes } from 'styled-components';


const floatAnimation = keyframes`
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-20px);
    }
    100% {
        transform: translateY(0);
    }
`;

export const Main = styled.main`
    background-color: black;
    display: flex;
    height: 700px;
    background-image: url(https://49truquespsicologicos.vercel.app/images/background-woman.jpg);
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
    padding: 9rem 1rem 0 1rem;

`

export const Container = styled.div`
    font-family: 'Sora', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;
    padding: 0 1rem;
    width: 400px;
	background-color: #00000070;
	backdrop-filter: blur(5px);
	border-radius: 15px;

    .vermelho {
        background: linear-gradient(90deg, #FF2905, #D83D1F, #C0392B, #9B1B1B);
        background-size: 200% 100%; 
        background-clip: text; 
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    h1 {
        position: relative;
        max-width: 400px;
        font-family: "Cinzel", serif;
        text-align: center;
        color: white;
        font-size: 25px;
        font-weight: bold;
        padding-bottom: 1rem;
        line-height: 2rem;
        margin-top: 1rem;

        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 300px;
            border-bottom: 1px solid #434040;
        }
    }

    img {
        width: 90%;
        margin-top: 1rem;
    }

    .title {
        width: 100%;
        margin-top: 0.5rem;
    }

    .paragrafoPrimeiro {
        color: #ffffff;
        text-align: center;
        font-size: 12pt;
        padding: 0 1rem;
        font-weight: 400;
        max-width: 450px;
        margin-top: -3rem;
        margin-bottom: 1.5rem;
    }
    
    .paragrafoFinal {
        color: #ffffff;
        margin-top: 1rem;
        margin-bottom: 2rem;
        max-width: 400px;
        text-align: center;
        font-size: 12pt;
        margin-bottom: 2.5rem;
    }
`;